import {
  Text,
  Stack,
  Heading,
  Box,
  Divider,
  Hidden,
  PageBlock,
  Page,
} from 'braid-design-system';

import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';

import Alliances from './components/Alliances/Alliances';
import BrandSearch from './components/BrandSearch/BrandSearch';
import FeaturedOpportunities from './components/FeaturedOpportunities/FeaturedOpportunities';
import FindAFranchiseOpp from './components/FindAFranchiseOpp/FindAFranchiseOpp';
import FranchiseeStories from './components/FranchiseeStories/FranchiseeStories';
import ReadyToBuy from './components/ReadyToBuy/ReadyToBuy';
import SellingAFranchise from './components/SellingAFranchise/SellingAFranchise';
import StartingOut from './components/StartingOut/StartingOut';

const Franchise = () => (
  <Page footer={<SiteWideFooter showNewsletterSignUp />}>
    <Header
      title="Buying a franchise"
      description="Buying a franchise? Whether you've just started or you're ready to buy, you'll find everything you need right here."
      url="/franchises-licensing-distribution"
    />

    <Hidden below="tablet">
      <Divider />
    </Hidden>

    <Box paddingTop="xlarge">
      <PageBlock width="medium">
        <Stack space="xxlarge">
          <Box background="brand" padding="xlarge" borderRadius="large">
            <Stack space="medium">
              <Heading level="2" component="h1">
                Buying a franchise
              </Heading>
              <Text>
                Whether you&apos;ve just started or you&apos;re ready to buy,
                you&apos;ll find everything you need right here.
              </Text>
            </Stack>
          </Box>

          <Stack space={{ mobile: 'xxlarge', tablet: 'xxxlarge' }}>
            <StartingOut />
            <FindAFranchiseOpp />
            <FeaturedOpportunities />
            <ReadyToBuy />
            <BrandSearch />
            <FranchiseeStories />
            <SellingAFranchise />
            <Alliances />
          </Stack>
        </Stack>
      </PageBlock>
    </Box>
  </Page>
);

export default Franchise;
